"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typography_1 = require("src/components/Typography");
var Icons_1 = require("src/components/Icons");
var StyledRadioButton_1 = require("./StyledRadioButton");
var RadioButton = function (_a) {
    var label = _a.label, checked = _a.checked, disabled = _a.disabled, value = _a.value, children = _a.children, name = _a.name, a11yTitle = _a.a11yTitle, margin = _a.margin, rest = __rest(_a, ["label", "checked", "disabled", "value", "children", "name", "a11yTitle", "margin"]);
    return (react_1.default.createElement(StyledRadioButton_1.StyledRadioButtonContainer, { as: "label", disabled: disabled, margin: margin },
        react_1.default.createElement(StyledRadioButton_1.StyledInputTypeRadio, __assign({ type: "radio", value: value, name: name, disabled: disabled, checked: checked }, rest)),
        react_1.default.createElement(StyledRadioButton_1.StyledIconContainer, { "aria-label": a11yTitle, checked: checked, height: "16px", width: "16px", alignItems: "center", justifyContent: "center", overflow: "hidden", round: 4, margin: [0, 2, 0, 0] }, checked && react_1.default.createElement(Icons_1.DotOutline10, { color: "brand500", size: 12 })),
        children,
        label && !children && react_1.default.createElement(Typography_1.Text, null, label)));
};
exports.default = RadioButton;
